import React from 'react';
import Map from '../components/Map';

const Home: React.FC = () => {
  return (
    <>
      <style>
        {`
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>

      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(120deg, #132d69ff, #1e293b, #1e3a8a, #020617)',
          backgroundSize: '300% 300%',
          animation: 'gradientShift 30s ease infinite',
          color: '#e5e7eb',
          padding: '20px 20px',
          boxSizing: 'border-box',
        }}
      >
        <h1
          style={{
            margin: '0px 0px 20px 10px',
            fontSize: 'clamp(24px, 4vw, 36px)',
            fontWeight: 700,
            letterSpacing: '0.5px',
            color: '#f8fafc',
            textShadow: '0 2px 6px rgba(0,0,0,0.5)',
          }}
        >
          Southeast Asia ❤️‍🔥
        </h1>

        <div
          style={{
            background: 'rgba(15, 23, 42, 0.55)', // coal glass effect
            borderRadius: '18px',
            padding: '20px',
            backdropFilter: 'blur(16px)',
            boxShadow: '0 12px 30px rgba(0, 0, 0, 0.35)',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <Map />
        </div>
      </div>
    </>
  );
};

export default Home;